// New customer (the legacy Add Customer modal and the WO picker's quick create both save through
// addNewCustomer, DockMaster-aware) and the Haul/Launch Week panel on the work order form
// (showWeekCounts). Moved out of app.js unchanged (docs/split-plan.md, session 6).
import { app } from './initFirebase';
import { usesDockmaster } from './marinaConfig';
import { escapeHTML, fetchIdToken, generateId, getDB, toastMessage, updateTimestamps } from './utilities';
import { formatShortDate } from './wo-ops-aggregation';
import { getFunctions, httpsCallable } from 'firebase/functions';

let shell = null;
export function setNewCustomerDeps(deps) { shell = deps; }

document.getElementById("addCustomer").addEventListener("click", async ()=>{
  try{
    document.getElementById('addNewCustomer').style.display="flex"
    document.getElementById('customerSalutation').focus()
    document.getElementById('newCustomerId').value = await generateId();
    document.getElementById('newBoatId').value = await generateId();
  }catch(error){
    console.error(error)
  }
})

export async function addNewCustomer(){

  try {
    toastMessage("Adding Customer. Please wait...", 'blue' ,2000)
    const idToken = await fetchIdToken();

    let customerId = document.getElementById('newCustomerId').value;
    let boatId = document.getElementById('newBoatId').value;
    let DMCustomer = await createCustomerDM();


    let firebaseUrl = `${shell.currentURL}/customers/${customerId}.json?auth=${idToken}`;

    var customerData = {
      Customer_ID : customerId,
      Salutation : document.getElementById('customerSalutation').value,
      Last_Name : document.getElementById('customerLastName').value,
      First_Name : document.getElementById('customerFirstName').value,
      Street : document.getElementById('customerStreet').value,
      City : document.getElementById('customerCity').value,
      State : document.getElementById('customerState').value,
      Zip : document.getElementById('customerZip').value,
      Phone : document.getElementById('customerPhone').value,
      Email : document.getElementById('customerEmail').value,
      DM_Customer: DMCustomer,
      Boats: {}
    }

  if(document.getElementById('customerBoatName').value !== ''){
    let DMBoat = await createBoatDM(DMCustomer);
    let boatData = {
      Boat_ID: boatId,
      Boat_Name : document.getElementById('customerBoatName').value,
      Boat_Length : document.getElementById('customerBoatLength').value,
      Boat_Beam : document.getElementById('customerBoatBeam').value,
      Combo_Key : document.getElementById('customerComboKey').value,
      Mast_Length : document.getElementById('customerMast').value,
      Boat_Type : document.getElementById('customerBoatType').value,
      Bottom_Paint_Product : document.getElementById('paintProduct')?.value || '',
      Bottom_Paint_Type : document.getElementById('paintType').value,
      Bottom_Paint_Color : document.getElementById('paintColor').value,
      Insurance_Company: document.getElementById('insuranceCompany').value,
      Insurance_Policy: document.getElementById('insurancePolicy').value,
      Customer_ID: customerId,
      DM_Boat: DMBoat
    }
    customerData.Boats[boatId] = boatData;
  }

    const options = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(customerData),
    };

    const response = await fetch(firebaseUrl, options);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();

    await addCustomerIndexedDB(customerData);
    await shell.fetchCustomerDataAndGenerateTable();
    shell.callNewCustomerAdded();
    toastMessage("Customer Added Successfully", 'green' ,2000)
    updateTimestamps('customerData','customers');
    document.getElementById('addNewCustomer').style.display = 'none';

  } catch (error) {
    console.error("Error adding custom field to customer:", error);
  }
}

async function createCustomerDM(){
  if (!usesDockmaster()) return '';
  try{
    const functions = getFunctions(app);
    const updateDMCustomer = httpsCallable(functions, 'updateDMCustomer');
    
    var dataLog = {
      "LastName": document.getElementById('customerLastName').value,
      "FirstName": document.getElementById('customerFirstName').value,
      "Address1": document.getElementById('customerStreet').value,
      "City": document.getElementById('customerCity').value,
      "State": document.getElementById('customerState').value,
      "Zip": document.getElementById('customerZip').value,
      "CellPhone": document.getElementById('customerPhone').value,
      "Email": document.getElementById('customerEmail').value,
    };

    const result = await updateDMCustomer(dataLog);
    const DMCustomerId = result.data.CustomerID;

    return DMCustomerId;
    
  } catch (error) {
    console.log(error);
    throw error; // Re-throw the error after logging it
  } 
}

async function addCustomerIndexedDB(customerInfo) {
  try {
    const db = await getDB();
    const transaction = db.transaction(['customerData'], 'readwrite');
    const store = transaction.objectStore('customerData');

    if (!customerInfo || !customerInfo.Customer_ID) {
      console.error('Customer data missing Customer_ID');
      return;
    }

    customerInfo.id = customerInfo.Customer_ID;

    await new Promise((resolve, reject) => {
      const req = store.put(customerInfo);
      req.onerror = () => reject(req.error);
      req.onsuccess = () => resolve();
    });

    console.log('Customer data added successfully to IndexedDB.');
  } catch (error) {
    console.error('Error adding customer to IndexedDB:', error);
  }
}


async function createBoatDM(DMCustomer){
  if (!usesDockmaster()) return '';
  try{
  const functions = getFunctions(app);
  const updateDMBoat = httpsCallable(functions, 'updateDMBoat');

  var dataLog = {
    "OwnerId": DMCustomer,
    "Name": document.getElementById('customerBoatName').value,
    "LOA": document.getElementById('customerBoatLength').value,
    "Beam": document.getElementById('customerBoatBeam').value,
    "Draft": document.getElementById('customerBoatDraft').value,
    "InsuranceCompany": document.getElementById('insuranceCompany').value
  };

  const result = await updateDMBoat(dataLog)

      var DMBoatId = result.data.BoatID;
      return DMBoatId;

}catch(error){
  console.log(error);
}
 
}

// Monday-of-week, matching haulLaunch.js's own mondayOf() so this panel
// agrees with how the actual Haul/Launch board groups its weeks.
function mondayOfWeek(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = (d.getDay() + 6) % 7; // 0 = Monday .. 6 = Sunday
  d.setDate(d.getDate() - day);
  return d;
}

// Lists every OTHER boat already scheduled to haul/launch the same
// Mon-Sun week as the date just entered, so staff can see the load on that
// week before committing to it (not just a bare count) — pulled live from
// IndexedDB's customerData rather than any date-range-limited snapshot, so
// it works for any season/year, not just whatever range was hardcoded at
// build time.
export async function showWeekCounts(kind) {
  const dateFieldId = kind === 'launch' ? 'work-order-form-dates-launch-date' : 'work-order-form-dates-haul-date';
  const dateStr = document.getElementById(dateFieldId).value;
  if (!dateStr) return;

  const weeksPanel = document.getElementById('week-count-container');
  const weekBody = document.getElementById('week-count-body');
  const weekTitle = document.getElementById('week-count-title');
  if (weekTitle) weekTitle.textContent = kind === 'launch' ? 'Launch Week' : 'Haul Week';
  weekBody.innerHTML = '<div class="week-count-loading">Loading&hellip;</div>';
  weeksPanel.style.display = 'flex';

  const weekStart = mondayOfWeek(new Date(dateStr + 'T00:00:00'));
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);

  const dateField = kind === 'launch' ? 'Launch_Date' : 'Haul_Date';
  const currentBoatId = document.getElementById('work-order-form-boat-id').value;

  let customers = [];
  try {
    customers = await shell.fetchDataFromStore('customerData');
  } catch (error) {
    console.error('Week count: failed to load customer data', error);
    weekBody.innerHTML = '<div class="week-count-empty">Could not load schedule data.</div>';
    return;
  }

  const matches = [];
  customers.forEach(customer => {
    if (!customer?.Boats) return;
    Object.values(customer.Boats).forEach(boat => {
      if (!boat || typeof boat !== 'object') return;
      if (boat.Boat_ID && boat.Boat_ID === currentBoatId) return; // "other boats" — exclude the one being edited
      const raw = boat[dateField];
      if (!raw) return;
      const d = new Date(raw + 'T00:00:00');
      if (isNaN(d) || d < weekStart || d > weekEnd) return;
      matches.push({
        boatName: boat.Boat_Name || 'Unnamed boat',
        boatLength: Number(boat.Boat_Length) || 0,
        customerName: [customer.Last_Name, customer.First_Name].filter(Boolean).join(', '),
        date: raw,
      });
    });
  });

  matches.sort((a, b) => a.date.localeCompare(b.date) || a.boatName.localeCompare(b.boatName));

  const rangeLabel = `${formatShortDate(weekStart)} – ${formatShortDate(weekEnd)}`;
  const verb = kind === 'launch' ? 'launching' : 'hauling';

  const rowsHtml = matches.length
    ? matches.map(m => `
        <div class="week-count-row">
          <span class="week-count-row-date">${formatShortDate(m.date + 'T00:00:00')}</span>
          <span class="week-count-row-boat">${escapeHTML(m.boatName)}${m.boatLength ? ` &middot; ${m.boatLength}'` : ''}</span>
          <span class="week-count-row-customer">${escapeHTML(m.customerName)}</span>
        </div>
      `).join('')
    : `<div class="week-count-empty">No other boats ${verb} this week.</div>`;

  weekBody.innerHTML = `
    <div class="week-count-header">
      <div class="week-count-range">${rangeLabel}</div>
      <div class="week-count-summary">${matches.length} other boat${matches.length === 1 ? '' : 's'} ${verb} this week</div>
    </div>
    ${rowsHtml}
  `;
}
